/* PB Recherche tolérante (15/10/2026) : complète la suggestion native Shopify par une correspondance approchée
   (fautes de frappe, phonétique, mots dans le désordre, nom de maison) sur un petit index du catalogue.
   Natif : l'index est une page Liquid du thème (templates/collection.pb-recherche-index.liquid). Aucun service externe, aucune IA. */
(function () {
  'use strict';
  var W = typeof window !== 'undefined' ? window : globalThis;
  if (W.PBRecherche) return;
  var D = typeof document !== 'undefined' ? document : null;
  var CFG = null, IDX = null, LOAD = null, SEQ = 0, MIN = 0.71, HM = 0.85, HS = {};   // HM : seuil d'une maison (nom de maison tapé, même mal) ; HS : maisons du catalogue
  var STOP = { de: 1, du: 1, des: 1, la: 1, le: 1, les: 1, l: 1, d: 1, of: 1, the: 1, a: 1, and: 1, et: 1, in: 1, on: 1, by: 1, eau: 1, parfum: 1, extrait: 1 };

  function cfg() {
    if (CFG || !D) return CFG;
    var el = D.querySelector('script[data-pb-recherche-config]');
    try { CFG = JSON.parse(el.textContent); } catch (e) { CFG = null; }
    return CFG;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }

  /* ---------- écriture « MAISON / nom du parfum » (15/10/2026) : JUMEAU de snippets/pb-titre-carte.liquid (affichage seulement, sans concentration) ---------- */
  function fold(s) { return String(s || '').toLowerCase().replace(/[éèêë]/g, 'e').replace(/[àâä]/g, 'a').replace(/[îï]/g, 'i').replace(/[ôöō]/g, 'o').replace(/[ùûü]/g, 'u').replace(/ç/g, 'c').replace(/œ/g, 'o').replace(/æ/g, 'a').replace(/ñ/g, 'n').replace(/ā/g, 'a').replace(/ē/g, 'e').replace(/ī/g, 'i').replace(/ū/g, 'u').replace(/[’‘´`ʼ]/g, "'"); }
  var SUFS = ['eau de parfum extreme', 'extrait de parfum', 'eau de parfum', 'eau de toilette', 'elixir de parfum', 'le parfum', 'parfum', 'elixir'];
  function carteTitre(vendor, title) {
    var dec = function (x) { return String(x || '').replace(/&amp;/g, '&').replace(/&#39;/g, "'").replace(/&quot;/g, '"'); };
    var v = dec(vendor).replace(/^\s+|\s+$/g, ''), t = dec(title).split(/ +/).filter(Boolean).join(' ');
    var tf = fold(t), vf = fold(v), label = v, cands = [vf], plen = 0, hit = '', i, c, rest, rf, k, s, n;
    if (vf === 'eminence') { cands = ['eminence i matti']; label = 'Eminence I Matti'; }
    else if (vf === 'stephane humbert lucas 777') { cands = [vf, 'stephane humbert lucas']; }
    else if (vf === 'jousset parfums') { cands = [vf, 'les mignardises by jousset']; }
    else if (vf === 'jul et mad paris') { cands = [vf, 'jul et mad']; }
    else if (vf === 'goldfield & banks') { cands = [vf, 'goldfield & bank']; }
    for (i = 0; i < cands.length; i++) { c = cands[i]; if (c && tf.substr(0, c.length) === c && tf.substr(c.length, 1) === ' ') { plen = c.length; hit = c; break; } }
    rest = t.substr(plen).replace(/^\s+|\s+$/g, ''); rf = tf.substr(plen).replace(/^\s+|\s+$/g, '');
    for (k = 0; k < SUFS.length; k++) {
      s = SUFS[k]; n = s.length;
      if (rf.length > n + 1 && rf.substr(rf.length - n) === s && rf.substr(rf.length - n - 1, 1) === ' ') { rest = rest.substr(0, rest.length - n - 1).replace(/\s+$/, ''); break; }
    }
    if (hit === 'les mignardises by jousset') rest = 'Les Mignardises — ' + rest;
    if (!rest) rest = t;
    return { maison: label, nom: rest.charAt(0).toUpperCase() + rest.substr(1) };
  }

  /* ---------- normalisation, phonétique, distance de Damerau-Levenshtein ---------- */
  function norm(s) {
    return String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
      .replace(/ø/g, 'o').replace(/œ/g, 'oe').replace(/æ/g, 'ae').replace(/ß/g, 'ss')
      .replace(/['’`´]/g, '').replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function pk(w) {
    w = w.replace(/ph/g, 'f').replace(/ch|sh/g, 'x').replace(/th/g, 't').replace(/gu(?=[eiy])/g, 'g').replace(/g(?=[eiy])/g, 'j')
      .replace(/qu|ck|q/g, 'k').replace(/c(?=[eiy])/g, 's').replace(/c/g, 'k').replace(/h/g, '')
      .replace(/eau|au/g, 'o').replace(/ou|oo/g, 'u').replace(/ai|ei|ay/g, 'e').replace(/y/g, 'i').replace(/w/g, 'v').replace(/z/g, 's')
      .replace(/(.)\1+/g, '$1');
    return w.length > 3 ? w.replace(/[estdxz]$/, '') : w;
  }
  var R0 = new Int32Array(40), R1 = new Int32Array(40), R2 = new Int32Array(40);
  function dl(a, b) {                                      // Damerau-Levenshtein (transposition d'une lettre voisine = 1)
    var la = a.length, lb = b.length, i, j, c, v, t, p0 = R0, p1 = R1, p2 = R2;
    if (!la) return lb;
    if (!lb) return la;
    if (la > 38 || lb > 38) return Math.max(la, lb);
    for (j = 0; j <= lb; j++) p1[j] = j;
    for (i = 1; i <= la; i++) {
      p2[0] = i;
      for (j = 1; j <= lb; j++) {
        c = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        v = Math.min(p1[j] + 1, p2[j - 1] + 1, p1[j - 1] + c);
        if (i > 1 && j > 1 && c && a.charCodeAt(i - 1) === b.charCodeAt(j - 2) && a.charCodeAt(i - 2) === b.charCodeAt(j - 1)) v = Math.min(v, p0[j - 2] + 1);
        p2[j] = v;
      }
      t = p0; p0 = p1; p1 = p2; p2 = t;
    }
    return p1[lb];
  }
  var VT = new Uint8Array(128), Z0 = new Float64Array(40), Z1 = new Float64Array(40), Z2 = new Float64Array(40), Z3 = new Float64Array(40), TR2 = 0.7;
  'aeiouy'.split('').forEach(function (c) { VT[c.charCodeAt(0)] = 1; });
  function dw(a, b) {                                      // Damerau-Levenshtein pondéré : voyelle pour voyelle = 0,5 ; voyelle oubliée ou en trop = 0,6 ; lettres voisines permutées = 0,6 ; deux lettres séparées par UNE lettre permutées (mahata / mataha) = 0,7 (les fautes de frappe et d'oreille les plus fréquentes)
    var la = a.length, lb = b.length, i, j, c, v, t, ca, cb, va, vb, p0 = Z0, p1 = Z1, p2 = Z2, pm = Z3;
    if (la > 38 || lb > 38) return Math.max(la, lb);
    p1[0] = 0;
    for (j = 1; j <= lb; j++) p1[j] = p1[j - 1] + (VT[b.charCodeAt(j - 1) & 127] ? 0.6 : 1);
    for (i = 1; i <= la; i++) {
      ca = a.charCodeAt(i - 1) & 127; va = VT[ca]; p2[0] = p1[0] + (va ? 0.6 : 1);
      for (j = 1; j <= lb; j++) {
        cb = b.charCodeAt(j - 1) & 127; vb = VT[cb];
        c = ca === cb ? 0 : va && vb ? 0.5 : 1;
        v = Math.min(p1[j] + (va ? 0.6 : 1), p2[j - 1] + (vb ? 0.6 : 1), p1[j - 1] + c);
        if (c && i > 1 && j > 1 && ca === (b.charCodeAt(j - 2) & 127) && (a.charCodeAt(i - 2) & 127) === cb) v = Math.min(v, p0[j - 2] + 0.6);
        if (c && i > 2 && j > 2 && ca === (b.charCodeAt(j - 3) & 127) && cb === (a.charCodeAt(i - 3) & 127) && (a.charCodeAt(i - 2) & 127) === (b.charCodeAt(j - 2) & 127)) v = Math.min(v, pm[j - 3] + TR2);
        p2[j] = v;
      }
      t = pm; pm = p0; p0 = p1; p1 = p2; p2 = t;
    }
    return p1[lb];
  }
  function lim(n) { return n < 3 ? 0 : n < 6 ? 1 : n < 9 ? 2 : 3; }

  /* ressemblance d'un mot tapé (q, clé phonétique pq) avec un mot de la fiche (t, clé pt) : 0 à 1 ; last = mot en cours de frappe */
  function sim(q, pq, t, pt, last) {
    if (q === t) return 1;
    var lq = q.length, lt = t.length, s = 0, d, m, L = lim(lq);
    if (/\d/.test(q) || /\d/.test(t)) return last && lq >= 2 && /^\d+$/.test(q) && t.indexOf(q) === 0 ? 0.9 : 0;
    if (last && lq >= 3 && lt > lq && t.indexOf(q) === 0) s = 0.92;
    if (last && lq >= 5 && lt > lq && dl(q, t.slice(0, lq)) <= 1) s = Math.max(s, 0.86);   // 4 lettres + 1 faute = trop de faux départs (cazn / carnaval)
    if (last && pq.length >= 3 && pt.length > pq.length && pt.indexOf(pq) === 0) s = Math.max(s, 0.9);
    if (Math.abs(lq - lt) <= L) {
      m = Math.max(lq, lt); d = dw(q, t);
      if (d <= (lq > 4 ? L + 0.5 : L) && d / m <= 0.34) s = Math.max(s, 1 - d / m);
    }
    if (pq.length >= 3 && pt.length >= 3 && Math.abs(pq.length - pt.length) <= 2) {
      m = Math.max(pq.length, pt.length); d = dl(pq, pt);
      if (d === 0) s = Math.max(s, 0.96);
      else if (d <= (m < 6 ? 1 : 2) && d / m <= 0.34) s = Math.max(s, 0.9 * (1 - d / m));
    }
    return s;
  }

  /* ---------- index ---------- */
  var VOC = { t: [], p: [], m: {} };                       // vocabulaire unique des mots du catalogue (chaque mot n'est comparé qu'une fois)
  function prep(it) {
    var seen = {}, w = [], j = [], seqs = [norm(it.t).split(' '), norm(it.b).split(' ')], k, i, x;
    for (k = 0; k < 2; k++) {
      x = seqs[k];
      for (i = 0; i < x.length; i++) {
        if (x[i] && !seen[x[i]]) { seen[x[i]] = 1; w.push(x[i]); }
        if (i && (x[i - 1] + x[i]).length >= 5) j.push(x[i - 1] + x[i]);
      }
    }
    x = seqs[1]; k = x.filter(function (z) { return z && !STOP[z]; });       // initiales de la maison : MFK = Maison Francis Kurkdjian
    if (k.length > 2) w.push(k.map(function (z) { return z[0]; }).join(''));
    k = x.filter(Boolean);
    if (k.length > 2) w.push(k.map(function (z) { return z[0]; }).join(''));
    var vw = [], vs = {}, id = function (z) {
      var n = VOC.m[z];
      if (n === undefined) { n = VOC.t.length; VOC.m[z] = n; VOC.t.push(z); VOC.p.push(/\d/.test(z) ? z : pk(z)); }
      return n;
    };
    it._i = w.concat(j).map(id);
    x = seqs[1];                                           // mots de la MAISON seule (nom de maison tapé, même mal) : mots, mots collés deux à deux, initiales
    for (i = 0; i < x.length; i++) {
      if (x[i] && !vs[x[i]]) { vs[x[i]] = 1; vw.push(x[i]); }
      if (i && (x[i - 1] + x[i]).length >= 5) vw.push(x[i - 1] + x[i]);
    }
    k = x.filter(function (z) { return z && !STOP[z]; });
    if (k.length > 2) vw.push(k.map(function (z) { return z[0]; }).join(''));
    k = x.filter(Boolean);
    if (k.length > 2) vw.push(k.map(function (z) { return z[0]; }).join(''));
    it._v = vw.map(id);
    return it;
  }
  function build(items) {
    VOC = { t: [], p: [], m: {} }; HS = {}; PQC = {}; PQN = 0; IDX = items.map(prep);
    IDX.forEach(function (x) { var k = norm(x.b); if (k) (HS[k] = HS[k] || { k: k, name: x.b, v: x._v, items: [] }).items.push(x); });
    return IDX;
  }
  function tok(s, stop, last) {                            // mot de la requête + sa ressemblance avec tout le vocabulaire
    var T = { s: s, p: /\d/.test(s) ? s : pk(s), stop: stop, last: last, v: new Float32Array(VOC.t.length), max: 0 }, i, x;
    for (i = 0; i < VOC.t.length; i++) { x = sim(T.s, T.p, VOC.t[i], VOC.p[i], last); T.v[i] = x; if (x > T.max) T.max = x; }
    return T;
  }
  var PQC = {}, PQN = 0;                                   // la même requête n'est analysée qu'une fois par décision
  function parseQuery(term, entier) {                      // entier : tous les mots sont tapés en entier (aucun mot « en cours de frappe »)
    var key = (entier ? '1' : '0') + term, w, t, i;
    if (PQC[key]) return PQC[key];
    if (PQN++ > 24) { PQC = {}; PQN = 0; }
    w = norm(term).split(' ').filter(Boolean); t = [];
    for (i = 0; i < w.length; i++) t.push(tok(w[i], !!STOP[w[i]], !entier && i === w.length - 1));
    return (PQC[key] = { t: t, n: w.join('').length, num: /^[\d ]+$/.test(norm(term)) });
  }
  function scoreTokens(T, ids) {
    var num = 0, den = 0, strong = 0, i, j, b, wt;
    for (i = 0; i < T.length; i++) {
      b = 0;
      for (j = 0; j < ids.length; j++) if (T[i].v[ids[j]] > b) b = T[i].v[ids[j]];
      wt = T[i].stop ? 0.25 : Math.min(T[i].s.length, 8);
      num += wt * b; den += wt;
      if (!T[i].stop && b >= MIN && !/\d/.test(T[i].s)) strong++;
    }
    return strong && den ? num / den : 0;
  }
  function variants(Q) {                                   // « contre jour » tapé pour « Contrejour » : deux mots fusionnés en un
    var out = [], i, a, b, m;
    for (i = 0; i < Q.t.length - 1; i++) {
      a = Q.t[i]; b = Q.t[i + 1];
      if ((a.s + b.s).length < 6) continue;
      m = tok(a.s + b.s, false, b.last);
      if (m.max >= 0.8) out.push(Q.t.slice(0, i).concat([m], Q.t.slice(i + 2)));
    }
    return out;
  }
  function rank(term) {
    var Q = parseQuery(term), V, L = [], i, s, k;
    if (!IDX || Q.n < 3 || Q.num) return [];
    V = variants(Q);
    for (i = 0; i < IDX.length; i++) {
      s = scoreTokens(Q.t, IDX[i]._i);
      for (k = 0; k < V.length && s < 0.95; k++) s = Math.max(s, scoreTokens(V[k], IDX[i]._i));
      if (s >= MIN) L.push({ p: IDX[i], s: s, i: i });
    }
    return L.sort(function (a, b) { return b.s - a.s || a.i - b.i; });
  }

  /* décision : que faut-il ajouter à ce que Shopify a déjà répondu ? (nat = poignées des produits natifs, dans l'ordre) */
  function decideBase(term, nat) {
    var L = rank(term), top, tied, n3, byH, ns, k, out, in_, sold, Q;
    if (!L.length) return [];
    top = L[0].s;
    tied = L.filter(function (x) { return x.s >= top - 0.03; });
    if (nat.length) {
      if (top < 0.8 || tied.length > 8) return [];                       // trop incertain, ou requête générique : le natif suffit
      n3 = nat.slice(0, 3);
      if (tied.some(function (x) { return n3.indexOf(x.p.h) >= 0; })) return [];   // le natif montre déjà le bon parfum dans les 3 premiers
      byH = IDX.filter(function (x) { return x.h === nat[0]; })[0];
      ns = byH ? scoreTokens(parseQuery(term).t, byH._i) : 0;
      if (ns >= top - 0.15) return [];                                    // le 1er résultat natif est lui aussi crédible : il reste en tête
    }
    out = L.filter(function (x) { return x.s >= Math.max(MIN, top - 0.06) && nat.slice(0, 3).indexOf(x.p.h) < 0; }).slice(0, 3).map(function (x) { return x.p; });
    in_ = out.filter(avail); sold = out.filter(function (x) { return !avail(x); });
    if (sold.length && nat.length) {                                      // Shopify range les épuisés en dernier, volontairement : un épuisé ne passe jamais devant
      Q = parseQuery(term).t;                                              // un résultat natif EN STOCK qui répond lui aussi à la requête
      if (nat.some(function (h) { var it = IDX.filter(function (x) { return x.h === h; })[0]; return it && avail(it) && scoreTokens(Q, it._i) >= top - 0.15; })) sold = [];
    }
    return in_.concat(sold);                                               // dans le bloc : les achetables d'abord, les épuisés ensuite (signalés « Épuisé »)
  }
  /* NOM DE MAISON : la requête entière est (à une faute près) le nom d'une maison du catalogue, et le 1er résultat natif n'est pas de cette maison
     -> la maison passe devant : ligne « Tous les parfums <maison> » + 1 à 2 de ses fiches. À score égal, une maison passe avant un parfum isolé
     (le 1er natif ne garde la tête que s'il est une correspondance EXACTE, ou s'il répond à la requête mieux que la maison). */
  function houseOf(Q, nat, term) {
    var best = null, second = 0, k, s, n0, ns, E;
    if (!nat.length || Q.n < 5) return null;                              // 4 lettres : trop de ressemblances de hasard (rhum / room)
    E = parseQuery(term, true);                                            // une maison ne se reconnaît que sur des mots entiers (« gold » n'est pas le début de « Goldfield »)
    for (k in HS) {
      s = scoreTokens(E.t, HS[k].v);
      if (!best || s > best.s) { if (best) second = best.s; best = { h: HS[k], s: s }; } else if (s > second) second = s;
    }
    if (!best || best.s < HM || second >= best.s - 0.03) return null;        // pas une maison, ou plusieurs maisons ressemblent autant (« maison », « paris »)
    n0 = IDX.filter(function (x) { return x.h === nat[0]; })[0];
    if (!n0) return null;
    if (norm(n0.b) === best.h.k) return null;                              // le 1er résultat natif est déjà de cette maison
    ns = scoreTokens(Q.t, n0._i);
    if (ns >= 0.99 || ns > best.s) return null;                            // correspondance exacte d'un autre parfum, ou parfum qui répond mieux
    return best;
  }
  function decide(term, nat) {
    var out = decideBase(term, nat), Q = parseQuery(term), H = houseOf(Q, nat, term), top3 = nat.slice(0, 3), mine, rest, res;
    if (!H) return out;
    mine = H.h.items.filter(function (x) { return top3.indexOf(x.h) < 0; });
    if (!mine.length) mine = H.h.items.slice();
    mine = mine.filter(avail).concat(mine.filter(function (x) { return !avail(x); })).slice(0, 2);
    rest = out.filter(function (x) { return norm(x.b) !== H.h.k; });
    res = mine.concat(rest).slice(0, 3);
    res.v = H.h.name;
    return res;
  }
  function avail(it) { return it.a !== 0; }
  function vendorOf(items) {
    var v = items.length > 1 && items.every(function (x) { return x.b === items[0].b; }) ? items[0].b : '';
    return v;
  }

  /* ---------- chargement : au premier focus, mis en cache pour la session ---------- */
  function css() {
    var c = cfg();
    if (!D || !c || !c.css || D.querySelector('link[data-pb-recherche-css]')) return;
    var l = D.createElement('link'); l.rel = 'stylesheet'; l.href = c.css; l.setAttribute('data-pb-recherche-css', ''); D.head.appendChild(l);
  }
  function page(n) {
    return fetch(CFG.url + '&page=' + n, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw 0; return r.text(); }).then(JSON.parse);
  }
  function load() {
    var c = cfg(), key, hit;
    if (LOAD) return LOAD;
    if (!c) return Promise.resolve([]);
    css();
    key = 'pbrt2:' + c.lang + ':' + c.cur;
    try { hit = JSON.parse(sessionStorage.getItem(key)); } catch (e) { hit = null; }
    if (hit && hit.t && Date.now() - hit.t < 1800000 && hit.i && hit.i.length) { build(hit.i); LOAD = Promise.resolve(IDX); return LOAD; }
    LOAD = page(1).then(function (p1) {
      var rest = [], n;
      for (n = 2; n <= p1.pages; n++) rest.push(page(n));
      return Promise.all(rest).then(function (r) {
        var all = p1.items.slice();
        r.forEach(function (p) { all = all.concat(p.items); });
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), i: all })); } catch (e) { }
        return build(all);
      });
    }).catch(function () { LOAD = null; return []; });
    return LOAD;
  }
  function suggest(term, nat) { return load().then(function () { return IDX ? decide(term, nat || []) : []; }); }

  /* ---------- rendu ---------- */
  function url(it) { return CFG.root.replace(/\/$/, '') + '/products/' + it.h; }
  function statut(it) { return it.a === 0 ? '<div class="pb-recherche__statut">' + esc(CFG.sold) + '</div>' : ''; }
  function rows(items, n) {
    var h = '', v = items.v || vendorOf(items), i, it, tc;
    if (v && CFG.brand_url) h += '<li id="pb-recherche-option-' + n + '-0" class="predictive-search__list-item" role="option" aria-selected="false"><a href="' + esc(CFG.brand_url + encodeURIComponent(v)) + '" class="predictive-search__item link link--text" tabindex="-1"><div class="predictive-search__item-content predictive-search__item-content--centered"><p class="predictive-search__item-heading h5">' + esc(CFG.brand_all) + ' ' + esc(v) + '</p></div></a></li>';
    for (i = 0; i < items.length; i++) {
      it = items[i];
      h += '<li id="pb-recherche-option-' + n + '-' + (i + 1) + '" class="predictive-search__list-item" role="option" aria-selected="false"><a href="' + esc(url(it)) + '" class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text" tabindex="-1">' +
        (it.i ? '<img class="predictive-search__image" src="' + esc(it.i) + '" alt="" width="50" height="' + Math.round(50 / (it.r || 1)) + '" loading="lazy">' : '') +
        '<div class="predictive-search__item-content"><div class="predictive-search__item-vendor caption-with-letter-spacing">' + esc((tc = carteTitre(it.b, it.t)).maison) + '</div><p class="predictive-search__item-heading h5">' + esc(tc.nom) + '</p>' +
        statut(it) + '</div></a></li>';
    }
    return h;
  }
  function mark(root) {                               // « Épuisé » aussi sur les lignes natives dont l'index dit qu'elles ne sont plus achetables (même information sur toutes les lignes)
    if (!IDX || !root) return 0;
    var n = 0, by = {};
    IDX.forEach(function (x) { by[x.h] = x; });
    Array.prototype.forEach.call(root.querySelectorAll('a[href*="/products/"]'), function (a) {
      var it = by[a.getAttribute('href').split('?')[0].split('/products/')[1]], c = a.querySelector('.predictive-search__item-content');
      if (!it || avail(it) || !c || c.querySelector('.pb-recherche__statut')) return;
      c.insertAdjacentHTML('beforeend', statut(it)); n++;
    });
    return n;
  }
  function menu(items) {                               // bloc inséré en tête de la liste de suggestions existante
    var n = ++SEQ, box = D.createElement('div');
    box.className = 'pb-recherche pb-recherche--menu'; box.setAttribute('data-pb-recherche', '');
    box.innerHTML = '<h2 id="pb-recherche-h-' + n + '" class="predictive-search__heading text-body caption-with-letter-spacing">' + esc(CFG.title) + '</h2>' +
      '<ul class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="pb-recherche-h-' + n + '">' + rows(items, n) + '</ul>';
    return box;
  }
  function renderPage(el) {                            // page /search sans résultat
    var term = el.getAttribute('data-terms') || '';
    suggest(term, []).then(function (items) {
      if (!items.length) return;
      var n = ++SEQ;
      el.className = 'pb-recherche pb-recherche--page';
      el.innerHTML = '<h2 id="pb-recherche-h-' + n + '" class="pb-recherche__titre h3">' + esc(CFG.title) + '</h2><ul class="pb-recherche__liste list-unstyled" aria-labelledby="pb-recherche-h-' + n + '">' + rows(items, n).replace(/ role="option" aria-selected="false"/g, '').replace(/ tabindex="-1"/g, '') + '</ul>';
      el.hidden = false;
    });
  }

  W.PBRecherche = { load: load, suggest: suggest, rank: rank, dw: dw, menu: menu, mark: mark, norm: norm, pk: pk, dl: dl, index: function (a) { build(a); LOAD = Promise.resolve(IDX); return IDX; }, config: function (c) { CFG = c; } };

  if (D) {
    var go = function (e) {
      var t = e.target;
      if (e.type === 'focusin' && !(t && t.matches && t.matches('input[type="search"]'))) return;
      if (e.type === 'pointerdown' && !(t && t.closest && t.closest('.header__icon--search'))) return;
      D.removeEventListener('focusin', go); D.removeEventListener('pointerdown', go);
      load();
    };
    D.addEventListener('focusin', go); D.addEventListener('pointerdown', go, { passive: true });
    var init = function () { cfg(); var el = D.querySelector('[data-pb-recherche-page]'); if (el && cfg()) renderPage(el); };
    if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
  }
})();
